// Layout preset geometry + UI labels (Sprint 9, docs/09 §C1). The GEOMETRY is the
// single shared source (`@seencast/shared` PRESET_ZONES) so the CMS picker, the CMS
// multi-zone preview, the API validator, and the player all agree by construction.
// This module re-exports that geometry and adds the CMS-only display labels.

export {
  LAYOUT_PRESETS,
  ZONE_IDS,
  PRESET_ZONES,
  nonMainZonesForPreset,
  type LayoutPreset,
  type ZoneId,
  type PresetZone,
  type ZoneRectPct,
} from '@seencast/shared';

import type { LayoutPreset, ZoneId } from '@seencast/shared';

/** Human labels for presets and zones (UI copy only). */
export const PRESET_LABELS: Record<LayoutPreset, string> = {
  fullscreen: 'Fullscreen',
  main_ticker: 'Main + ticker',
  main_side: 'Main + side panel',
  l_shape: 'L-shape',
};

export const ZONE_LABELS: Record<ZoneId, string> = {
  main: 'Main',
  side: 'Side panel',
  ticker: 'Ticker',
};
